import {Injectable} from '@angular/core';
import {AngularFirestore} from 'angularfire2/firestore';
import {Observable} from 'rxjs/Observable';
import {Subject} from 'rxjs/Subject';
import {TenantDB, TenantWithID} from '../../interfaces/tenant.interface';


@Injectable()
export class FirebaseTenantService {

  constructor(private afs: AngularFirestore) {
  }


  /**
   *
   * @param {string} uid
   * @returns {Observable<DocumentChangeAction[]>}
   */
  getTenantsPerProperty(org_id: string, property_id: string): Observable<any> {
    const list = this.afs.collection<any>('organizations')
      .doc(org_id).collection('properties').doc(property_id).collection('users',
        users => users.where('role', '==', 'tenant'));

    return list.snapshotChanges();
  }


  /**
   * Get Active tenant of Property at
   * [ORGANIZATIONS > ORG_ID > PROPERTIES > PROPERTY_ID > USERS ]
   * @param {string} org_id
   * @param {string} property_id
   * @returns {Observable<TenantWithID[]>}
   */
  getActiveTenantAtProperty(org_id: string, property_id: string): Observable<TenantWithID[]> {
    const list = this.afs.collection<any>('organizations')
      .doc(org_id).collection('properties').doc(property_id).collection('users',
        users => users.where('role', '==', 'tenant').where('status', '==', true));

    return list.snapshotChanges().map(actions => {
      return actions.map(item => {
        const data = item.payload.doc.data() as TenantDB;
        const id = item.payload.doc.id;
        return {id, ...data};
      });
    });
  }


  /**
   *
   * @param {string} uid
   * @returns {Observable<DocumentChangeAction[]>}
   */
  checkActiveTenantsPerProperty(org_id: string, property_id: string): Observable<any> {
    const list = this.afs.collection<any>('organizations')
      .doc(org_id).collection('properties').doc(property_id).collection('users',
        users => users.where('status', '==', true));

    return list.snapshotChanges();
  }


  /**
   *
   * @param {string} uid
   * @returns {Observable<DocumentChangeAction[]>}
   */
  getTenantOfPropertyByUid(org_id: string, property_id: string, uid: string): Observable<any> {
    const tenantRef = this.afs.collection<any>('organizations')
      .doc(org_id).collection('properties').doc(property_id).collection('users').doc(uid);

    return tenantRef.valueChanges();
  }


  /**
   *
   * @param {string} org_id
   * @param {string} property_id
   * @param tenant_id
   * @param {boolean} value
   * @returns {Observable<any>}
   */
  updateTenantStatus(org_id: string, property_id: string, tenant_id, value: boolean) {
    const object = this.afs.collection<any>('organizations')
      .doc(org_id).collection('properties').doc(property_id)
      .collection('users').doc(tenant_id);

    const transaction = object.update({
      status: value
    });

    return this.fromFirebaseAuthPromise(transaction);
  }


  /**
   *
   * @param {string} org_id
   * @param {string} property_id
   * @param tenant_id
   * @param {boolean} value
   * @returns {Observable<any>}
   */
  deleteTenantByToggelActive(org_id: string, property_id: string, tenant_id) {
    const object = this.afs.collection<any>('organizations')
      .doc(org_id).collection('properties').doc(property_id)
      .collection('users').doc(tenant_id);

    const transaction = object.update({
      active: false
    });

    return this.fromFirebaseAuthPromise(transaction);
  }


  /**
   * @param {string} org_id
   * @param {string} property_id
   * @param {string} tenant_id
   * @param formData
   * @returns {Observable<any>}
   */
  updateTenantAtProperty(org_id: string, property_id: string, tenant_id: string, formData: any): Observable<any> {

    const tenantRef = this.afs.collection<any>('organizations').doc(org_id).collection('properties')
      .doc(property_id).collection('users').doc(tenant_id);


    // Populate fields on Repair object //
    const transaction = tenantRef.update({
      firstName: formData.firstName,
      lastName: formData.lastName,
      address: formData.address,
      phone: formData.phone,
      movedIn: formData.movedIn,
    });

    return this.fromFirebaseAuthPromise(transaction);

  }


  // Convert Promise of Firebase to an Observable
  fromFirebaseAuthPromise(promise): Observable<any> {

    const subject = new Subject<any>();

    promise
      .then(res => {
          subject.next(res);
          subject.complete();
        },
        err => {
          subject.error(err);
          subject.complete();
        }
      );
    return subject.asObservable();
  }


}



// WEBPACK FOOTER //
// C:/Clients/rent-hero/web-application/src/app/_shared/services/firebase/tenant.service.ts